(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["servings-price"] && !Shopify.designMode) return;
  try {
    (() => {
    /*
     * Pitch fires:
     *
     * variant:update
     *
     * The fresh server-rendered product HTML is available at:
     *
     * event.detail.data.html
     *
     * We use that HTML because Liquid has already calculated the
     * correct servings metafield and price for the newly selected variant.
     */

    const updateNutrigizeServingPrice = (event) => {
      const newHtml = event.detail?.data?.html;

      if (!newHtml) return;

      const newServingBlock = newHtml.querySelector(
        '[data-nutrigize-serving-price]'
      );

      const currentBlocks = document.querySelectorAll(
        '[data-nutrigize-serving-price]'
      );

      if (!currentBlocks.length) return;

      /*
       * If the selected variant has no servings value,
       * the server-rendered block will still exist but will
       * be hidden.
       */
      if (!newServingBlock) {
        currentBlocks.forEach((currentBlock) => {
          currentBlock.hidden = true;
        });

        return;
      }

      /*
       * Copy the freshly rendered contents from Shopify's
       * response into the existing block.
       *
       * We deliberately keep the existing outer element so
       * Pitch's DOM/morph system is not disturbed.
       */
      currentBlocks.forEach((currentBlock) => {
        currentBlock.hidden = newServingBlock.hidden;

        currentBlock.innerHTML = newServingBlock.innerHTML;
      });
    };

    /*
     * Listen to Pitch's native variant update event.
     */
    document.addEventListener(
      'variant:update',
      updateNutrigizeServingPrice
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
